import { ca } from '@cian/analytics';

/**
 * @description Событие: клик по промо-баннеру (ипотечный баннер на лендинге).
 */
export function trackPromoBannerClick(): void {
  ca('eventSite', {
    action: 'click_promo_banner',
    category: 'Promo',
    label: 'mortgage_banner',
    name: 'oldevent',
    useLastProducts: true,
  });
}
